import React from 'react';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import delay from 'mn-utils/delay';
import isEmail from 'mn-utils/isEmail';
import isEqual from 'mn-utils/isEqual';
import noop from 'mn-utils/noop';
import trim from 'mn-utils/trim';
import upperFirst from 'mn-utils/upperFirst';
import {
  apiV2UsersCreate,
  apiV2UsersEdit,
} from '../../../../../../api/merchant/users';
import {
  PERMISSIONS_DEFAULT,
  PERMISSIONS_FINANCE,
  PERMISSIONS_MERCHANTS_ADMIN,
  PERMISSIONS_SALES,
} from '../../../../../../constants/permissions';
import {
  openPopupWindow,
} from '../../../../../../emitters/popup';
import ButtonN from '../../../../../dumb/Button/Accept';
import Field from '../../../../../dumb/Field/E';
import Loading from '../../../../../dumb/Loading';
import Popup from '../../../../../dumb/Popup/B';
import Ripple from '../../../../../dumb/Ripple';
import TextField from '../../../../../dumb/TextField/A';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import openPopupUserAccessEdit from './openPopupUserAccessEdit';
import ButtonM from "../../../../../dumb/Button/Decline";


module.exports = (data, callback) => {
  data = data || {};

  const isValidEmail = (v) => (
    !!(
      v && v.length < 255
      && /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9]+)?@[a-z0-9-]+(\.[a-z0-9-]{2,})+$/i
        .exec(v)
    )
  )

  openPopupWindow((setState, self) => {
    const {
      close,
    } = self;
    const changeProvider = changeProviderProvider(setStateOfCurrent);

    const handleChangeEmail = changeProvider('email');
    const handleChangeName = changeProvider('name');
    const handleChangeRole = changeProvider('role');

    const id = data.id;

    let _cancelAccountCheckEmail = noop;
    let _emailCheching;

    const stateOfLast = {
      email: data.email || '',
      name: data.name || '',
      role: data.role || '',
      settings: {
        ...PERMISSIONS_DEFAULT,
        ...(data.settings || {}),
      },
    };
    self.state = {
      loadingCheckEmail: false,
      alreadyUsedEmail: false,
      clicked: false,
      stateOfCurrent: stateOfLast,
    };

    function setStateOfCurrent(stateOfCurrent) {
      setState({
        stateOfCurrent: {
          ...self.state.stateOfCurrent,
          ...stateOfCurrent,
        },
      });
    }
    function handleOpenAccessEdit() {
      openPopupUserAccessEdit(self.state.stateOfCurrent.settings, (settings) => {
        setStateOfCurrent({
          settings: {
            ...self.state.stateOfCurrent.settings,
            ...settings,
          },
        });
      });
    }

    return (state) => {
      const {
        clicked,
        alreadyUsedEmail,
        loadingCheckEmail,
        stateOfCurrent,
      } = state;
      const {
        email,
        name,
        role,
        settings,
      } = stateOfCurrent;

      const MAX_LENGTH = 250;

      const _email = trim(email);
      const _name = trim(name);
      const _role = trim(role);

      const _invalidEmail = !isValidEmail(_email);
      const invalidEmail = id ? false : _invalidEmail || alreadyUsedEmail;
      const invalidName = !_name;
      const invalidRole = !_role;


      id || _invalidEmail || _emailCheching === _email;

      const changed = !isEqual(stateOfLast, stateOfCurrent);
      const disabled = invalidEmail || invalidName || invalidRole || loadingCheckEmail;

      let accessSettingsTitle = 'custom';
      isEqual(settings, PERMISSIONS_DEFAULT) && (accessSettingsTitle = 'L1');
      isEqual(settings, PERMISSIONS_MERCHANTS_ADMIN) && (accessSettingsTitle = 'admin');
      isEqual(settings, PERMISSIONS_FINANCE) && (accessSettingsTitle = 'finance');
      isEqual(settings, PERMISSIONS_SALES) && (accessSettingsTitle = 'sales');

      return (
        <Popup
          caption="Add user"
        >
          <WrapperWithLoading
            loading={state.loading}
          >
            <div className="cfx mt20 mh-28 (lt|ph28|pb28|w1/2|w@m2)>1">
              <div>
                <div className="rlv">
                  <TextField
                    label="Email *"
                    value={email}
                    onChange={handleChangeEmail}
                    error={clicked && invalidEmail || !_invalidEmail && !loadingCheckEmail && alreadyUsedEmail}
                    maxLength={MAX_LENGTH}
                    helperText={_email ? (
                      alreadyUsedEmail
                        ? 'This login is already used'
                        : 'This email is not valid'
                    ) : 'Obligatory field'}
                    disabled={!!id}
                  />
                  {
                    loadingCheckEmail ? (
                      <div className="abs srb sq45 z1">
                        <Loading/>
                      </div>
                    ) : null
                  }
                </div>
              </div>
              <div>
                <TextField
                  label="Name  *"
                  value={name}
                  maxLength={MAX_LENGTH}
                  onChange={handleChangeName}
                  error={clicked && invalidName}
                  helperText="Obligatory field"
                />
              </div>
              <div>
                <TextField
                  label="Role  *"
                  value={role}
                  maxLength={MAX_LENGTH}
                  onChange={handleChangeRole}
                  error={clicked && invalidRole}
                  helperText="Obligatory field"
                />
              </div>
              <Field label={`Access Settings: ${upperFirst(accessSettingsTitle)}`}>
                <Ripple
                  className="layoutRow fhaC fvaC w170 h45 f12 fw4 lh lts0em r9
                    bs b1 bcCT ov olN tdN dn c5B47FF c7B67FF:h"
                  onClick={handleOpenAccessEdit}
                >
                  Choose
                </Ripple>
              </Field>
            </div>
            <div className="mt40 cfx mh-28 (lt|ph28|pb20)>1">
              <div>
                <ButtonN
                  disabled={!changed || clicked && disabled}
                  onClick={() => {
                    if (disabled) {
                      setState({
                        clicked: true,
                      });
                      return;
                    }
                    setState({
                      loading: true,
                    });

                    const params = {
                      email: _email,
                      name: _name,
                      role: _role,
                      settings: stateOfCurrent.settings,
                    };
                    (
                      id
                        ? (
                        params.id = id,
                        apiV2UsersEdit(params)
                      )
                      : apiV2UsersCreate(params)
                    ).finally((error) => {
                      setState({
                        loading: false,
                      });
                      if (error) {
                        return;
                      }
                      close();
                      callback && callback();
                    });
                  }}
                >Save</ButtonN>
              </div>
              <div>
                <ButtonM
                  onClick={close}
                >Cancel</ButtonM>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
